<template>
  <div v-if="listData.length > 0">
    <table class="b2b-grid b2b-grid--collapse is-compact" qaid="saved-list-sku-grid">
      <thead class="b2b-grid__header">
        <!-- Each Header -->
        <tr>
          <th class="b2b-grid__cell b2b-grid__head" qaid="notification-grid-header.checkbox">
            <label class="checkbox">
              <input
                id="notification-settings-select-all"
                v-model="selectAllCheckboxes"
                type="checkbox"
                @change="toggleSelectAll"
              />
              <span class="control-indicator"></span>
            </label>
          </th>
          <th class="b2b-grid__cell b2b-grid__head uppercase" qaid="notification-grid-header.sku">
            {{ $t('text.account.savedLists.sku') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head uppercase" qaid="notification-grid-header.item">
            {{ $t('productCompare.description') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head uppercase" qaid="notification-grid-header.upc">
            {{ $t('text.account.savedLists.upc') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head uppercase" qaid="notification-grid-header.upc">
            {{ $t('text.warehouse') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head uppercase" qaid="notification-grid-header.upc">
            {{ $t('text.originalETA') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head uppercase" qaid="notification-grid-header.upc">
            {{ $t('text.currentETA') }}
          </th>
          <th
            class="b2b-grid__cell b2b-grid__head uppercase whitespace-nowrap"
            data-type="stock-watch"
            qaid="notification-grid-header.stockwatch"
          >
            {{ $t('text.etaWatch') }}
          </th>

          <th class="b2b-grid__cell b2b-grid__head uppercase" qaid="notification-grid-header.price">
            {{ $t('order.price') }}
          </th>
        </tr>
      </thead>

      <tbody>
        <template v-for="(item, itemIndex) in paginatedData">
          <tr :key="item.id">
            <td class="b2b-grid__cell lg:table-cell">
              <label class="checkbox">
                <input
                  :id="`item-${itemIndex}`"
                  v-model="item.checkboxActive"
                  type="checkbox"
                  :disabled="item.etaWatch === false"
                />
                <span class="control-indicator"></span>
              </label>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="notification-grid.sku">
              <div class="b2b-grid__label uppercase">{{ $t('text.account.savedLists.sku') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.sku}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="notification-grid.itemname">
              <div class="b2b-grid__label uppercase">{{ $t('productCompare.description') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.itemName}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="notification-grid.upc">
              <div class="b2b-grid__label uppercase">{{ $t('text.account.savedLists.upc') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.upc}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="notification-grid.warehouse">
              <div class="b2b-grid__label uppercase">{{ $t('text.warehouse') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.warehouse}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="notification-grid.warehouse">
              <div class="b2b-grid__label uppercase">{{ $t('text.originalETA') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.etaDate}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="notification-grid.warehouse">
              <div class="b2b-grid__label uppercase">{{ $t('text.originalETA') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.estimatedShipDate}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="notification-grid.stockwatch">
              <div class="b2b-grid__label uppercase">{{ $t('text.account.savedLists.stockWatch') }}</div>
              <div class="b2b-grid__content">
                <grid-eta-watch :eta-item="item" :token="token" />
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="notification-grid.price">
              <div class="b2b-grid__label uppercase">{{ $t('order.price') }}</div>
              <div class="b2b-grid__content">
                <grid-price :data="{dealerCost: item.unitPrice}"></grid-price>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <div class="md:flex md:justify-end">
      <div class="md:flex md:flex-grow text-center">
        <pagination
          v-if="pageCount > 1"
          ref="pagination"
          qaid="notification-grid.pagination"
          :page-number="pageNumber"
          :page-count="pageCount"
          @page-change="pageChange"
          @prev-page="prevPage"
          @next-page="nextPage"
        ></pagination>
      </div>

      <div class="buttons buttons--right">
        <trek-button
          primary
          qaid="notification-grid.removebutton"
          :disabled="selectedSkus.length === 0"
          @click="openDialog"
        >
          <span>{{ $t('notifications.B2B.removeWatch') }}</span>
        </trek-button>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      :title="$t('notifications.B2B.delete.check')"
      :center="true"
      :show-close="true"
      :close-on-press-escape="true"
      :close-on-click-modal="false"
      :z-index="16000011"
      :close-dialog-tooltip="$t('popup.close')"
      qaid="notification-grid.modal"
      @close="closeDialog"
    >
      <template slot="footer">
        <div class="buttons buttons--center">
          <trek-button alert qaid="notification-grid.delete.yes" @click="confirmDelete">
            <span>{{ $t('notifications.B2B.delete.yesDelete') }}</span>
          </trek-button>
          <trek-button secondary qaid="notification-grid.delete.no" @click="closeDialog">
            <span>{{ $t('notifications.B2B.delete.noSave') }}</span>
          </trek-button>
        </div>
      </template>
    </el-dialog>
  </div>
  <div v-else>
    <pdl-callout>
      <template #content>
        <span v-html="noItem" />
      </template>
    </pdl-callout>
  </div>
</template>

<script>
import pagination from '../../../mixins/pagination';
import ElDialog from '../../Dialog.vue';
import axios from 'axios';
import {PdlCallout} from '@pedal/pdl-callout';
import GridText from '@/components/grid/GridText';
import GridEtaWatch from '@/components/grid/GridEtaWatch';
import GridPrice from '@/components/grid/GridPrice';
import Pagination from '@/components/Pagination';
import TrekButton from '@/components/TrekButton';

export default {
  components: {ElDialog, GridText, PdlCallout, GridEtaWatch, GridPrice, Pagination, TrekButton},
  mixins: [pagination],
  props: {
    token: {
      type: String,
      default: '',
    },
    columns: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    size: {
      type: Number,
      required: false,
      default: 15,
    },
    noItem: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      selectAllCheckboxes: false,
      dialogVisible: false,
    };
  },
  computed: {
    listData() {
      return this.items;
    },
    selectedSkus() {
      return this.items.filter((item) => item.checkboxActive === true && item.etaWatch === true);
    },
  },
  methods: {
    toggleSelectAll(event) {
      this.items.map((item) => {
        item.checkboxActive = event.target.checked;
        return item;
      });
    },
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    confirmDelete() {
      this.dialogVisible = false;
      let successCallCounter = 0,
        failureCallCounter = 0,
        totalCallsToMake = this.selectedSkus.length;

      this.selectedSkus.map((mappedItem) => {
        axios
          .delete(`/my-account/etawatch/${mappedItem.etaWatchId}?CSRFToken=${this.token}`)
          .then(
            ({
              data: {
                meta: {feedback},
              },
            }) => {
              if (feedback.type === 'success') {
                successCallCounter++;
              } else {
                failureCallCounter++;
              }

              /* NOTE: Show success message when all selected items have successfully updated */
              if (successCallCounter === totalCallsToMake) {
                this.$emit('update-data-list');
                this.$notify({
                  type: 'success',
                  message: this.$t('notifications.B2B.delete.confirmation'),
                });
              } else if (successCallCounter + failureCallCounter === totalCallsToMake) {
                /* NOTE: Just update the table when at least one item failed to be updated */

                this.$emit('update-data-list');
              }
            }
          )
          .catch((error) => console.log(error));
      });
    },
  },
};
</script>
